import React, { createContext, useContext } from 'react';
import cc from 'classcat';
import FakeInput from '@cobalt/react-fake-input';
import Popup from '@cobalt/react-popup';
import { Portal } from '@cobalt/react-portal-provider';
import usePosition from '@cobalt/react-position-hook';
import useResize from '@cobalt/react-resize-hook';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-dropdown_1-0-3_co-dropdown {\n  width: 100%;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.react-dropdown_1-0-3_co-dropdown__content {\n  min-width: 100px;\n  cursor: pointer;\n}\n\n.react-dropdown_1-0-3_co-dropdown.react-dropdown_1-0-3_co-dropdown--borderless {\n  width: auto;\n  min-width: auto;\n  max-width: 100%;\n}\n.react-dropdown_1-0-3_co-dropdown.react-dropdown_1-0-3_co-dropdown--borderless .react-dropdown_1-0-3_co-dropdown__input {\n  border: none;\n  height: auto;\n  padding: 0;\n}";
var styles = {
  "co-dropdown": "react-dropdown_1-0-3_co-dropdown",
  "co-dropdown__content": "react-dropdown_1-0-3_co-dropdown__content",
  "co-dropdown--borderless": "react-dropdown_1-0-3_co-dropdown--borderless",
  "co-dropdown__input": "react-dropdown_1-0-3_co-dropdown__input"
};
styleInject(css);

const DropdownContext = createContext(null);

const Dropdown = ({
  className = "",
  borderless = false,
  direction = "down",
  open = false,
  forwardedRef,
  ...props
}) => {
  const classStyles = cc([styles["co-dropdown"], {
    [styles["co-dropdown--borderless"]]: borderless
  }, className]);
  return React.createElement(DropdownContext.Provider, {
    value: {
      direction,
      open
    }
  }, React.createElement("div", _extends({
    ref: forwardedRef,
    className: classStyles
  }, props, {
    "data-co-name": "Dropdown",
    "data-co-version": "1.0.3",
    "data-co-project": "cobalt"
  })));
};

const Input = ({
  className = "",
  ...props
}) => {
  const dropdownContext = useContext(DropdownContext);
  const focus = !!dropdownContext && dropdownContext.open;
  const classes = cc([styles["co-dropdown__input"], className]);
  return React.createElement(FakeInput, _extends({
    className: classes,
    "data-co-focus": focus || undefined
  }, props));
};

const Content = ({
  className = "",
  inputRef,
  style,
  ...props
}) => {
  const dropdownContext = useContext(DropdownContext);
  const visible = dropdownContext ? dropdownContext.open : false;
  const direction = dropdownContext ? dropdownContext.direction : "down";
  const classes = cc([styles["co-dropdown__content"], className]);
  const popupOrigin = direction === "down" ? "SW" : "NW";
  const popupDirection = direction === "down" ? "SE" : "NE";
  const {
    position
  } = usePosition(inputRef, {
    origin: popupOrigin,
    direction: popupDirection,
    autoGap: 4
  });
  const {
    width: widthResize
  } = useResize(inputRef);
  return React.createElement(Portal, null, React.createElement(Popup, _extends({
    className: classes,
    visible: visible,
    style: { ...style,
      ...position,
      width: widthResize
    }
  }, props)));
};

export default Dropdown;
export { Content, Input };
